import {Accordion, AccordionDetails, styled} from '@mui/material';

const StyledAccordion = styled(Accordion)`
	border: none;
	box-shadow: none;
	border-radius: 8px;
`;

const StyledAccordionDetails = styled(AccordionDetails)`
	padding: 0px 16px 24px;
`;

export {StyledAccordion, StyledAccordionDetails};
